import React, { PureComponent } from 'react';
import { mdiChevronLeft } from '@mdi/js';
import { Container, ButtonContainer, ButtonIcon, Title } from './modal-bar.styles';

class ModalBar extends PureComponent {
  render() {
    const { target } = this.props.location.state;
    return (
      <Container>
        <ButtonContainer onClick={() => this.props.history.goBack()}>
          <ButtonIcon path={mdiChevronLeft} color={'#4a4a4a'} size={'32px'} />
        </ButtonContainer>
        <Title>
          {
            target === 'visit-details' && 'Visit details'
          }
          {
            target === 'touchpoint-details' && 'Touchpoint details'
          }
        </Title>
      </Container>
    );
  }
}

export default ModalBar;
